module.exports = __webpack_public_path__ + "fa-solid-900.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = 23
// module chunks = 0